<template>
  <v-card>
    <v-stepper v-model="step">
      <v-stepper-content step="1">
        <v-card-text class="headline secondary--text">
          <div>
            Por favor, aguarde...
          </div>
          <div class="subtitle-1 grey--text text--darken-2">
            Estamos carregando algumas informações
          </div>
        </v-card-text>
        <v-card-text>
          <v-progress-circular size="150" indeterminate color="primary"></v-progress-circular>
        </v-card-text>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-slide-y-transition>
          <v-chip color="primary" class="font-weight-light" v-if="user">{{user.email}}</v-chip>
        </v-slide-y-transition>
        <v-card-text class="headline secondary--text pb-0">
          Insira sua nova senha
        </v-card-text>
        <v-container class="pb-0">
          <v-form v-model="valid" ref="form">
            <v-row justify="center">
              <v-col xs="12" md="8">
                <v-text-field
                  v-model="password"
                  label="Nova senha"
                  outlined
                  hide-details
                  :type="show_password ? 'text'  : 'password'"
                  :append-icon="show_password ? 'mdi-eye-off'  : 'mdi-eye'"
                  @click:append="show_password = !show_password"
                  required
                  :rules="[
                    v => !!v || ''
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col xs="12" md="8">
                <v-text-field
                  v-model="confirm_password"
                  label="Confirme a senha"
                  outlined
                  :type="show_confirmation ? 'text'  : 'password'"
                  :append-icon="show_confirmation ? 'mdi-eye-off'  : 'mdi-eye'"
                  @click:append="show_confirmation = !show_confirmation"
                  required
                  :rules="[
                    v => v == password || 'As senhas não conferem'
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            block
            color="green"
            @click="mudarSenha()"
            :loading="loading"
          >CONFIRMAR ALTERAÇÃO</v-btn>
        </v-card-actions>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-card-text class="headline secondary--text">Parabéns</v-card-text>
        <v-card-text
          class="title grey--text text--darken-2 pt-0 font-weight-regular"
        >A sua senha foi alterada com sucesso</v-card-text>
      </v-stepper-content>
    </v-stepper>
  </v-card>
</template>

<script>
export default {
  props: ['actionCode'],
  data () {
    return {
      step: 1,
      valid: false,
      confirm_password: null,
      password: null,
      show_password: false,
      show_confirmation: false
    }
  },
  watch: {
    user (val) {
      if (val) {
        this.step = 2
      }
    }
  },
  mounted () {
    this.$store.dispatch('validarCodigoSenha', this.actionCode)
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    mudarSenha () {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('resetarSenha', {
            actionCode: this.actionCode,
            password: this.password
          })
          .then(() => {
            this.step++
          })
      }
    }
  }
}
</script>
